var FreeBetWinningType;
(function (FreeBetWinningType) {
    FreeBetWinningType[FreeBetWinningType["Win"] = 0] = "Win";
    FreeBetWinningType[FreeBetWinningType["BetPlusWin"] = 1] = "BetPlusWin";
})(FreeBetWinningType || (FreeBetWinningType = {}));

export { FreeBetWinningType };
